import { useTranslation } from "react-i18next";
import { useStyles } from "./ActionPlanTypeCell.styles";
import { IActionPlanTypeCell } from "./ActionPlanTypeCellInterfaces";
import ActionPlanIcon from "pages/Corporate/RCA/images/action_plan_icon.svg";

const ActionPlanTypeCell = ({ actionPlan }: IActionPlanTypeCell) => {
    const classes = useStyles();
    const { t } = useTranslation();
    return (
        <div className={classes.actionPlanTypeCellWrapper}>
            <img src={ActionPlanIcon} alt="Action plan icon" />
            <span>{`${t("rca.ap")}-${actionPlan.action_plan_id}`}</span>
        </div>
    );
};

export default ActionPlanTypeCell;
